(() => {
  if (customElements.get('fr-locked-drop')) return;
  customElements.define('fr-locked-drop', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.panels = [...this.querySelectorAll('[data-lock-panel]')];
      this.heading = this.querySelector('[data-lock-heading]');
      this.signup = this.querySelector('[data-lock-signup]');
      this.status = this.querySelector('[data-lock-status]');
      this.classList.add('is-ready');
      this.onHash = () => this.select(true);
      window.addEventListener('hashchange', this.onHash);
      window.addEventListener('popstate', this.onHash);
      window.addEventListener('pageshow', this.onShow = () => this.select(false));
      this.select(false);
    }
    select(focus) {
      const url = new URL(location.href);
      const match = /^#drop-(\d{3})$/.exec(location.hash);
      const token = location.hash.startsWith('#drop-') ? (match ? match[1] : '') : url.searchParams.get('drop');
      const number = /^\d{3}$/.test(token || '') ? Number(token) : 0;
      const selected = number >= 1 && number <= 40 ? this.panels.find(panel => panel.id === `drop-${token}`) : null;
      if (this.currentToken === token && this.currentValid === Boolean(selected)) return;
      this.currentToken = token;
      this.currentValid = Boolean(selected);
      if (selected) {
        if (url.searchParams.get('drop') !== token) { url.searchParams.set('drop', token); history.replaceState(null, '', url); }
        const returnInput = this.signup.querySelector('input[name=return_to]');
        if (returnInput) returnInput.value = `${location.pathname}?view=locked-drop&drop=${token}#drop-${token}`;
      }
      this.panels.forEach(panel => { panel.hidden = panel !== selected; panel.classList.toggle('is-active', panel === selected); });
      this.heading.textContent = selected ? selected.dataset.title : this.dataset.choose;
      this.signup.hidden = !selected || selected.dataset.state !== 'locked';
      this.querySelectorAll('[data-lock-number]').forEach(link => {
        if (selected && link.hash === `#${selected.id}`) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
      document.title = `${this.heading.textContent} | ${this.dataset.titleSuffix}`;
      this.status.textContent = selected ? `${selected.dataset.title}. ${selected.querySelector('h2').textContent}` : this.dataset.choose;
      if (focus) { this.heading.focus({ preventScroll: true }); this.heading.scrollIntoView({ block: 'start', behavior: 'instant' }); }
    }
    disconnectedCallback() { window.removeEventListener('hashchange', this.onHash); window.removeEventListener('popstate', this.onHash); window.removeEventListener('pageshow', this.onShow); this.ready = false; this.currentToken = undefined; }
  });
})();
